import {call, put, takeLatest, debounce} from "redux-saga/effects";
import {cronjobActions} from "./cronjobSlice";
import {cronjobApi} from "../../api";

function* fetchCronJobList(action)
{
    try
    {
        const response = yield call(cronjobApi.gets, action.payload);
        yield put(cronjobActions.fetchDataSuccess(response));
    }
    catch (error)
    {
        let message = error.message;
        if(error?.response?.data?.message) message = error.response.data.message;
        yield put(cronjobActions.fetchDataFailed(message));
    }
}

function* handleSearchDebounce(action)
{
    yield put(cronjobActions.setFilter(action.payload));
}

export default function* cronjobSaga()
{
    yield takeLatest(cronjobActions.fetchData.type, fetchCronJobList);
    yield debounce(500, cronjobActions.setFilterWithDebounce.type, handleSearchDebounce);
}
